import { StyleSheet } from 'aphrodite';
import { githubPanelStyles } from './githubPanelStyles';
import { threadTimelineStyles } from './threadTimelineStyles';
import { ticketTopBarStyles } from './ticketTopBarStyles';

export const styles = StyleSheet.create({
	...ticketTopBarStyles,
	...threadTimelineStyles,
	...githubPanelStyles,
});
